import {useEffect} from 'react'

// Добавить CSS классы к <body> на время существования компонента.
// При изменении или демонтаже компонента убирает добавленные ранее CSS классы из <body>.
export function useBodyCssClasses(classes: string | string[]) {
    useEffect(() => {
        const array: string[] = Array.isArray(classes) ? classes : classes.split(/ +/)
        document.body.classList.add(...array)
        return () => {
            document.body.classList.remove(...array)
        }
    }, [classes])
}
